import { createTelemetry, createTelemetryObject } from '@shared/core';

const category = 'SearchBanner';

export const searchBannerTelemetry = createTelemetryObject({
  actions: {
    findAEventRegistryClicked: eventType => ({
      action: 'FindAEventRegistry',
      category,
      actionType: 'click',
      label: 'find a event or registry',
      pagePrefix: 'marketing',
      extraInfo: { eventType }
    })
  },
  pages: {}
});

const { TelemetryProvider, useTelemetry: useSearchBannerTelemetry } = createTelemetry(searchBannerTelemetry);

export { TelemetryProvider, useSearchBannerTelemetry };
